import { MatchHeight } from "@plugins";

const neededSelectors = ["[data-mh='instruction-title']", "[data-mh='instruction-block']"];

for (const iterator of neededSelectors) {
    new MatchHeight(iterator);
}
